module.exports = __webpack_public_path__ + "img/ursula.4d78403a.jpg";